import { IoClose } from "react-icons/io5";

// OptionsForBooking هي عناصر قائمة هالكومبوننت
function ListItem2({ listItem2 }) {
  return (
    <li className="flex items-center gap-2 mb-2">
      <IoClose className="text-[24px] text-[#ec4735]" />
      {listItem2}
    </li>
  );
}

export default ListItem2;
